import { type MutationHookOptions, useMutation } from "@apollo/client";
import { ReissueContractPaymentInvoiceMutation } from "../graphql/mutations";
import type {
  ReissueContractPaymentInvoiceMutationType,
  ReissueContractPaymentInvoiceMutationVariablesType,
} from "@/types/graphql/admin.generated";

export const useReissueContractPaymentInvoiceMutation = (
  options?: MutationHookOptions<
    ReissueContractPaymentInvoiceMutationType,
    ReissueContractPaymentInvoiceMutationVariablesType
  >
) => {
  return useMutation<
    ReissueContractPaymentInvoiceMutationType,
    ReissueContractPaymentInvoiceMutationVariablesType
  >(ReissueContractPaymentInvoiceMutation, options);
};
